import { useHorizontalTicksAndScale } from './useHorizontalTicksAndScale.js';

function useHorizontalXScale({
  allNumbers,
  isStacked,
  labelFormatter,
  maxWidth,
  stackedMax = 0,
  stackedMin = 0,
  longestLabel
}) {
  let drawableWidth = maxWidth;
  let chartXPosition = 0;
  const labelWidth = longestLabel.positive + longestLabel.negative;
  drawableWidth -= labelWidth;
  chartXPosition += labelWidth / 2;
  const {
    xScale,
    ticks,
    ticksFormatted
  } = useHorizontalTicksAndScale({
    maxWidth: drawableWidth,
    allNumbers,
    labelFormatter,
    isStacked,
    stackedMin,
    stackedMax
  });
  return {
    xScale,
    ticks,
    ticksFormatted,
    drawableWidth,
    chartXPosition
  };
}

export { useHorizontalXScale };
